/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { Link } from "@packages/framework";
import type { ReactNode } from "react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../global/emotion";
import { spacing } from "../../../../global/emotion";
import type { HallowElementProps } from "../../../types/hallowElementProps.types";
import type { ButtonProps } from "../../_base/_core/Button/Button.emotion";
import { Button } from "../../_base/_core/Button/Button.emotion";

const baseStyle: Interpolation<ThemeType> = (theme) => ({
  alignSelf: "flex-start",
  backgroundColor: "transparent",
  color: theme.semanticColors.accentMedium,
  display: "flex",
  ":focus-visible": { color: theme.semanticColors.accentLower },
  ":hover": { color: theme.semanticColors.accentLow },
  ":active": { color: theme.semanticColors.accentHigher },
});

const stylesSize: Record<ButtonLinkProps["size"], Interpolation> = {
  s: {
    paddingLeft: "none",
    paddingRight: "none",
  },
  m: {
    paddingLeft: "none",
    paddingRight: "none",
    paddingTop: spacing.s,
    paddingBottom: spacing.s,
  },
  l: {
    paddingLeft: "none",
    paddingRight: "none",
    paddingTop: spacing.m,
    paddingBottom: spacing.m,
  },
};

export type ButtonLinkProps = {
  linkProps: HallowElementProps<"a">;
  buttonProps: Omit<ButtonProps, "isFullWidth" | "size" | "variant">;
  size?: "s" | "m" | "l";
  children: ReactNode;
};

//TODO: Add support for variants - for now it always uses the accent variant

export const ButtonLink = forwardRef<any, ButtonLinkProps>(
  ({ size = "m", children, linkProps, buttonProps, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        size={size}
        asChild
        css={[baseStyle, stylesSize[size]]}
        {...(buttonProps as ButtonProps)}
        {...props}
      >
        <Link {...linkProps}>{children}</Link>
      </Button>
    );
  },
);

ButtonLink.displayName = "ButtonLink";
